import React from 'react';
import {view} from '@sail/ui';

export function StripeAssistantResponse({
  children,
}: {
  children: React.ReactNode;
}) {
  return <view.div>{children}</view.div>;
}
